module.exports = __webpack_public_path__ + "static/img/LOUIS-EMMETT.3ecbd06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOUIS-EMMETT.jpg
// module id = d5Sa
// module chunks = 0